import { FC } from "react";
import { useParams } from "react-router";
import { Link } from "react-router-dom";
import { Section, SectionHeader, SectionTitle } from "../../ui-share";
import { Segment } from "../../../../../utils/Segment";
import { State } from "../../../../../utils/store";
import { useAppSelector } from "../../../../../utils/hooks";

interface AskScottProps {
  companyUuid: string;
}

export const AskScott: FC<AskScottProps> = ({ companyUuid }) => {
    const { clientSlug } = useParams<{ clientSlug: string }>();
    const { selectedClient } = useAppSelector((state: State) => state.clients);
    const { user } = useAppSelector((state: State) => state.auth);

    const handleClick = () => {
      Segment.analytics?.track("research-company-with-scott", {
        companyUUID: companyUuid,
        clientUUID: selectedClient?.uuid,
        userUUID: user?.uuid,
        source: "company-detail"
      });
    };

    return (
      <Section>
        <SectionHeader>
          <SectionTitle>Ask Scott</SectionTitle>
        </SectionHeader>
        <Link 
          to={`/${clientSlug}/scott/${companyUuid}`}
          onClick={handleClick}
        >
          Click here to research this company with Scott
        </Link>
    </Section>
    );
};
